//@flow
import React from 'react';
import { Container } from 'flux/utils';
import LoginForm from './LoginForm.react';
import SessionStore from '../../Stores/Session/session';
import CustomerStore from '../../Stores/Customer/customer';

type Props = {
  initialNewUser:boolean,
  modal?:boolean,
  inReferral?:boolean,
  hideSignInOptions?:boolean,
  hideHDYHAU?:boolean,
  emailValidation?:(email:string)=>?string,
  title?:string,
  subtitle?:string,
  emailPlaceholder?:string,
  passwordPlaceholder?:string,
};

type State = {
  defaultEmail:?string,
  isExistingUserEmail:boolean,
  isGhostAccountEmail:boolean,
  resetPasswordSuccess:boolean,
  unauthorized:boolean,
};

class LoginFormWrapper extends React.Component<Props, State> {
  static getStores() {
    return [
      SessionStore,
      CustomerStore,
    ];
  }

  static calculateState(prevState:State, props:Props):State {
    return {
      defaultEmail: CustomerStore.getCustomerEmail(),
      isExistingUserEmail: CustomerStore.isExistingUserEmail(),
      isGhostAccountEmail: CustomerStore.isGhostAccountEmail(),
      resetPasswordSuccess: CustomerStore.getResetPassword(),
      emailDomainValidationError: CustomerStore.getEmailDomainValidationError(),
      unauthorized: SessionStore.isLoginError(),
    };
  }

  render() {
    return (
      <LoginForm
        {...this.state}
        {...this.props}
      />
    );
  }
}

export default Container.create(LoginFormWrapper, { withProps: true });
